






































































import Vue from "vue"
import { Company } from "@/model/entity/company/company"
import { companyService } from "@/model/service/company/company-service"
import { ElForm } from "element-ui/types/form"
import log from "loglevel"
import { initial } from "lodash"

export default Vue.extend({
  data() {
    return {
      rules: {
        name: [
          { required: true, message: this.$t("user_administration.company.name_validation"), trigger: "change" },
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        delisUser: [
          {
            required: true,
            message: this.$t("user_administration.company.delis_username_validation"),
            trigger: "change"
          },
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        dswCode: [
          {
            required: true,
            message: this.$t("user_administration.company.dsw_code_validation"),
            trigger: "change"
          },
          {
            max: 20,
            message: `${this.$t("user_administration.max")} 20 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        comment: [
          {
            max: 128,
            message: `${this.$t("user_administration.max")} 128 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        delisPass: [
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            message: this.$t("user_administration.company.status_validation"),
            trigger: "change"
          }
        ]
      },
      companyEnabled: true,
      companyStatusLabel: "",
      disabledStatusesValue: [],
      statusesFromAPI: companyService.getDefaultStatuses(),
      statuses: []
    }
  },
  props: {
    company: {
      type: Object as () => Company,
      required: true
    },
    formValid: {
      type: Boolean,
      required: true
    },
    initialCompanyStatus: {
      type: String,
      required: true
    }
  },

  methods: {
    validateForm() {
      const form = this.$refs["form"] as ElForm
      let validationResult = false
      this.$nextTick(() => {
        if (!!form) {
          form.validate(valid => {
            validationResult = valid
          })
        }
        this.$emit("update:form-valid", validationResult)
      })
    },

    async generateStatusDropDown() {
      for (const status of this.statuses) {
        if (status.name !== "ENABLED") {
          this.disabledStatusesValue.push(status)
        }
      }
    }
  },
  watch: {
    companyEnabled: {
      handler() {
        if (this.companyEnabled) {
          this.company.status = "ENABLED"
        } else {
          if (this.initialCompanyStatus === "ENABLED") {
            this.company.status = this.disabledStatusesValue[0].name
          } else {
            this.company.status = this.initialCompanyStatus
          }
        }
      }
    },
    company: {
      immediate: true,
      deep: true,
      handler() {
        this.validateForm()
        this.companyEnabled = this.company.status === "ENABLED"
      }
    }
  },

  async created() {
    this.statuses = await this.statusesFromAPI.then(response => {
      return response.data
    })

    this.validateForm()
    this.generateStatusDropDown()
    const form = this.$refs["form"] as ElForm
  }
})
